export const gtagWrapper = (...args: any) => {
  if ("gtag" in window) {
    (window as any).gtag(...args);
  }
};

if (!window.RPR) {
  window.RPR = {} as any;
}

const trackEvent: typeof window.RPR.gtag.trackEvent = (
  action,
  otherProps,
  config
) => {
  const calculatedProps = { ...otherProps };

  if (typeof config === "object" && config.counter === true) {
    const count = window.RPR.gtag.counter[action];
    const newCount = count ? count + 1 : 1;

    window.RPR.gtag.counter[action] = newCount;
    calculatedProps.clickedTimes = newCount;
  }

  gtagWrapper("event", action, calculatedProps);
};

window.RPR.gtag = {
  debugMode: true,
  counter: {}, // keeps all counters
  trackEvent,
};

type AddTrackClickEventArgs = {
  id?: string;
  element?: Element;
  eventLabel: string;
  eventAction: string;
  eventCategory: string;
};

const addTrackClickEvent = ({
  id,
  element,
  eventLabel,
  eventAction,
  eventCategory,
}: AddTrackClickEventArgs) => {
  const trackElement = id ? document.getElementById(id) : element;

  if (!trackElement) {
    throw new Error(`Element not found: ${id}`);
  }
  trackElement.addEventListener("click", () => {
    trackEvent(
      eventAction,
      { event_label: eventLabel, event_category: eventCategory },
      { counter: true }
    );
  });
};

// export const initGaEvents = () => {
//   addTrackClickEvent({
//     // share tracking
//     id: "shareIcon",
//     eventLabel: "opening native navigator share",
//     eventAction: "clickedShareButton",
//     eventCategory: "buttonClick",
//   });

//   addTrackClickEvent({
//     //cta tracking
//     id: "ctaIcon",
//     eventLabel: "user clicked cta button",
//     eventAction: "clickedCTAButton",
//     eventCategory: "buttonClick",
//   });

//   setTimeout(() => {
//     addTrackClickEvent({
//       // privacy link tracking
//       id: "privacyPolicy",
//       eventLabel: "opening privacy model",
//       eventAction: "privacyPolicyLinkTracker",
//       eventCategory: "buttonClick",
//     });

//     addTrackClickEvent({
//       // privacy link tracking
//       id: "privacyLeaveButton",
//       eventLabel: "leaving AR experience to rpr privacy page",
//       eventAction: "privacyPolicyPageTracker",
//       eventCategory: "buttonClick",
//     });
//   }, 2000); // 2 seconds so loading module has time to load
// };

export const trackOpenPrivacy = () => {
  trackEvent(
    "privacyPolicyLinkTracker",
    {
      eventLabel: "opening privacy model",
      eventAction: "privacyPolicyLinkTracker",
      eventCategory: "buttonClick",
    },
    { counter: true }
  );
};

export const trackPrivacyLeave = () => {
  trackEvent(
    "privacyPolicyPageTracker",
    {
      eventLabel: "leaving AR experience to rpr privacy page",
      eventAction: "privacyPolicyPageTracker",
      eventCategory: "buttonClick",
    },
    { counter: true }
  );
};

export const trackCTAClick = () => {
  trackEvent(
    "clickedCTAButton",
    {
      eventLabel: "user clicked cta button",
      eventAction: "clickedCTAButton",
      eventCategory: "buttonClick",
    },
    { counter: true }
  );
};

export const trackShareClick = () => {
  trackEvent(
    "clickedShareButton",
    {
      eventLabel: "opening native navigator share",
      eventAction: "clickedShareButton",
      eventCategory: "buttonClick",
    },
    { counter: true }
  );
};

export const trackBottleTap = (age: string) => {
  if (age === "18") {
    trackEvent(
      "18OldTapped",
      {
        eventLabel: "user click 18 yr old bottle",
        eventAction: "18OldTapped",
        eventCategory: "bottleCategory",
      },
      { counter: true }
    );
  } else if (age === "21") {
    trackEvent(
      "21OldTapped",
      {
        eventLabel: "user click 21 yr old bottle",
        eventAction: "21OldTapped",
        eventCategory: "bottleCategory",
      },
      { counter: true }
    );
  } else if (age === "25") {
    trackEvent(
      "25OldTapped",
      {
        eventLabel: "user click 25 yr old bottle",
        eventAction: "25OldTapped",
        eventCategory: "bottleCategory",
      },
      { counter: true }
    );
  }
};

export const trackFoodPaired = (age: string) => {
  console.log(age);
  if (age === "18") {
    trackEvent(
      "18OldFoodPaired",
      {
        eventLabel: "user paired food with 18yr old bottle",
        eventAction: "18OldFoodPaired",
        eventCategory: "foodPaired",
      },
      { counter: true }
    );
  } else if (age === "21") {
    trackEvent(
      "21OldFoodPaired",
      {
        eventLabel: "user paired food with 21yr old bottle",
        eventAction: "21OldFoodPaired",
        eventCategory: "foodPaired",
      },
      { counter: true }
    );
  } else if (age === "25") {
    trackEvent(
      "25OldFoodPaired",
      {
        eventLabel: "user paired food with 25yr old bottle",
        eventAction: "25OldFoodPaired",
        eventCategory: "foodPaired",
      },
      { counter: true }
    );
  }
};

export const userActivatedAR = () => {
  trackEvent(
    "arActivated",
    {
      eventLabel: "user started AR experience",
      eventAction: "arActivated",
      eventCategory: "userFlow",
    },
    { counter: true }
  );
};

export const trackReachedEnd = () => {
  trackEvent(
    "usersReachedFinalAnimation",
    {
      eventLabel: "user reached the end of the experience",
      eventAction: "usersReachedFinalAnimation",
      eventCategory: "userFlow",
    },
    { counter: true }
  );
};

// initGaEvents();
